import { Delete, Folder } from '@mui/icons-material';
import { ListItemIcon, MenuItem } from '@mui/material';
import { FC } from 'react';

type SubroutineFolderProps = {
  subroutineId?: number;
  folderId?: number;
  newFolder: () => void;
  deleteFolder: (id: number) => void;
};

const SubroutineFolder: FC<SubroutineFolderProps> = (props) => {
  return (
    <>
      <MenuItem onClick={() => props.newFolder()}>
        <ListItemIcon>
          <Folder fontSize='small' />
        </ListItemIcon>
        Add folder
      </MenuItem>
      {props.folderId && !props.subroutineId && (
        <MenuItem onClick={() => props.folderId && props.deleteFolder(props.folderId)}>
          <ListItemIcon>
            <Delete fontSize='small' />
          </ListItemIcon>
          Remove folder
        </MenuItem>
      )}
    </>
  );
};

export default SubroutineFolder;
